var map = {
	"./Alimentos-y-bebidas-01.webp": 7304,
	"./Alimentos-y-bebidas-02.webp": 2261,
	"./Eventos-Masivos-01.webp": 7236,
	"./Eventos-Masivos-02.webp": 3953,
	"./Ind-Manufacturera-01.webp": 6135,
	"./Ind-Manufacturera-02.webp": 8230,
	"./Ind-cosmetica-y-belleza-01.webp": 463,
	"./Ind-cosmetica-y-belleza-02.webp": 1166,
	"./Ind. Manufacturera 02.webp": 2992,
	"./Industria-farmaceutica-01.webp": 1666,
	"./Industria-farmaceutica-02.webp": 9315,
	"./Otras-Industrias-01.webp": 5889,
	"./Otras-Industrias-02.webp": 4292,
	"./Vinos-y-Licores-01.webp": 8184,
	"./Vinos-y-Licores-02.webp": 613,
	"./alimentosimg.png": 9270
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1501;